import './ClientScreen.scss';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import PaletteIcon from '@mui/icons-material/Palette';
import { Helmet } from 'react-helmet';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { isWhitelabel } from 'src/utils/utils';


import ClientPropertiesForm from './ClientPropertiesForm';
import FacilityImageUpload from 'src/component/UI/FacilityImageUpload';
import IpWhitelistSection from './IpWhitelistSection';
import Button from 'src/component/UI/Button';
import PermissionFence from 'src/component/PermissionFence';
import FeatureFence from 'src/component/FeatureFence';

import { getClient } from 'src/module/authentication/selector';
import { fetchClient } from 'src/module/authentication/action';
import UsersList from 'src/component/UsersList';
import { useTranslation } from 'src/i18n';

export default function ClientScreen () {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();

  const client = useSelector(getClient);
  useEffect(() => {
    dispatch(fetchClient());
  }, []);

  const title = isWhitelabel() ? 'ATCOM' : 'SmartTrace';

  return (
    <div className='page' id="client" data-testid='client-screen'>
      <Helmet>
        <title>{title} - {t('settings.facility')}</title>
      </Helmet>

      <h2>{t('settings.facilitySettings')}</h2>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper>
            <ClientPropertiesForm />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper>
            <FacilityImageUpload />
          </Paper>
          <Paper style={{ marginTop: '16px' }}>
            <IpWhitelistSection />
          </Paper>
        </Grid>

        <FeatureFence can='beta'>
          <PermissionFence can='edit-client'>
            <Grid item xs={12} md={6}>
              <Paper>
                <div className='dashboard-settings-panel'>
                  <Typography
                    variant="body1"
                    component="label"
                    sx={{
                      display: 'block',
                      lineHeight: 1.43,
                      textTransform: 'uppercase',
                      marginBottom: '8px',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: 'text.secondary',
                    }}
                  >
                    {t('dashboard.dashboardSettings')}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" gutterBottom sx={{ fontSize: '12px' }}>
                    {t('dashboard.dashboardSettingsDescription')}
                  </Typography>
                  <div className='dashboard-settings-footer'>
                    <Button icon={<PaletteIcon />} cta onClick={() => history.push('/', { editDashboard: true })}>
                      {t('dashboard.editDashboard')}
                    </Button>
                  </div>
                </div>
              </Paper>
            </Grid>
          </PermissionFence>
        </FeatureFence>

        <Grid item xs={12}>
          <Paper>
            <h2>{t('admin.users')}</h2>
            <UsersList client={client} />
          </Paper>
        </Grid>
      </Grid>

    </div>
  );
}
